import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';
interface AdminBlogState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}

const defaultColumnList = [
  {
    name: 'title',
    label_key: 'blog',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'is_featured',
    label_key: 'is_featured',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    type: 'select',
    filter_placeholder: 'featured_all',
    selectKey: 'status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 2,
  },
  {
    name: 'views',
    label_key: 'views',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
  {
    name: 'category',
    label_key: 'category',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'asyncselect',
    filter_placeholder: 'category_all',
    asyncKey: 'blog_category',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 4,
  },
  {
    name: 'created_by',
    label_key: 'author',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'asyncselect',
    filter_placeholder: 'author_all',
    asyncKey: 'blog_author',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 5,
  },
  // {
  //   name: 'description',
  //   label_key: 'description',
  //   allow_list: true,
  //   allow_filter: false,
  //   show_list_checkbox: true,
  //   show_filter_checkbox: true,
  //   order: 3,
  // },
  {
    name: 'created_at',
    label_key: 'published_date',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 6,
  },
  {
    name: 'blog_status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'blog_status',
    option_value_key: 'slug',
    option_label_key: 'name',
    multi: false,
    order: 7,
  },
];

const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));

const initialState: AdminBlogState = {
  excludedFilter: ['search'],
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminBlogSlice = createSlice({
  name: 'adminBlog',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setBlogTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      // console.log(action.payload);
      state.tableColumnList = action.payload;
    },
  },
});

export const { setFilterData, resetFilterData, setReloadTableData, setBlogTableColumnList } =
  adminBlogSlice.actions;

export default adminBlogSlice.reducer;
